export default function error() {
  return (target, key, descriptor) => {
    descriptor.value.prototype = Object.create(Error.prototype);
    descriptor.value.prototype.constructor = (...args) => {
      descriptor.value.apply(this, args);
      // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
      this.stack = new Error().stack;
    };

    return descriptor;
  };
}
